export default __webpack_public_path__ + "static/media/password.f568bf94.png";